








































































import { AccountTypeEnum, PartyModel, TenantUserModel, WorkTaskEvaluationGroupModel, WorkTaskEvaluationModel, WorkTaskRuleModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { partiesStore } from '../+state/store';
import EvaluationDialog from '../components/EvaluationDialog.vue';
import EvaluationPlanDialog from '../components/EvaluationPlanDialog.vue';
import { workTaskEvaluationsGroupsStore } from '@/libs/work-task-evaluation-groups/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { workTaskRulesStore } from '@/libs/work-task-rules/+state/store';
import { useObjectKey } from '@/libs/common/functions/use-object-key';
import { CrudPartialUpdatePatch } from '@/libs/core/+state/models/crud-partial-update-patch';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { cloneDeep } from 'lodash';

@Component({
    components: {
        EvaluationDialog,
        EvaluationPlanDialog
    }
})
export default class Evaluations extends Page {

    newEvaluationDate: string | null = null;
    workTaskEvaluationGroup: WorkTaskEvaluationGroupModel | null = null;
    workTaskEvaluations: WorkTaskEvaluationModel[] = [];
    planDialog = false;

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    @Ref() evaluationDialog!: EvaluationDialog;

    evaluateClick() {
        const previousWorkTaskEvaluationGroup = this.workTaskEvaluationGroups.length > 0 ? this.workTaskEvaluationGroups[0] : null;
        this.evaluationDialog.open(null, this.partyId, null, previousWorkTaskEvaluationGroup);
    }

    get workTaskEvaluationGroups (): WorkTaskEvaluationGroupModel[] {
        const items = [...workTaskEvaluationsGroupsStore.useGetter(CrudGetter.Data)] as WorkTaskEvaluationGroupModel[];
        if (items?.length > 0 && !this.workTaskEvaluationGroup) {
            items[0].workTaskEvaluations!.sort((a: WorkTaskEvaluationModel, b: WorkTaskEvaluationModel) => {
                if(a.workTaskRule!.catalogueItem!.name! < b.workTaskRule!.catalogueItem!.name!) { return -1; }
                if(a.workTaskRule!.catalogueItem!.name! > b.workTaskRule!.catalogueItem!.name!) { return 1; }
                return 0;
            });
            this.showGroup(items[0]);
        }
        return items;
    }

    get workTaskRules (): WorkTaskRuleModel[] {
        return [...workTaskRulesStore.useGetter(CrudGetter.Data)];
    }

    get loading(): boolean {
        return workTaskRulesStore.useGetter(CrudGetter.Pending);
    }

    get party(): PartyModel {
        return {...partiesStore.useGetter(CrudGetter.Detail)};
    }

    @Watch("nextWorkTaskEvaluationDate")
    nextWorkTaskEvaluationDateChanged (v: string | null, p: string | null) {
        if (v != p && this.party) {
            partiesStore.dispatch(CrudAction.PartialUpdate, { id: this.party.id, diff: [
                { op: 'replace', path: useObjectKey<PartyModel>('nextWorkTaskEvaluationDate'), value: v } as CrudPartialUpdatePatch
            ] });
        }
    }

    mounted () {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
            this.$router.replace({
                name: "PartyGeneral",
                params: {
                    tenantId: this.$router.currentRoute.params.tenantId,
                    partyId: this.$router.currentRoute.params.partyId,
                }
            })
        }
        else {
            this.loadWorkTaskEvaluationGroups();
            this.loadWorkTaskRules();
        }
    }

    loadWorkTaskRules () {
        workTaskRulesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskRuleModel>(undefined, [
            { field: "partyId", op: "eq", comparand: this.partyId! }
        ]))
    }

    loadWorkTaskEvaluationGroups (changed = false) {
        this.showGroup(null);
        workTaskEvaluationsGroupsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<WorkTaskEvaluationGroupModel>([{field: "time", index: 1, order: "desc"}], [
            { field: "partyId", op: "eq", comparand: this.partyId }
        ]));
        if (changed) {
            partiesStore.dispatch(CrudAction.Get, { id: this.partyId });
        }
    }

    showGroup (item: WorkTaskEvaluationGroupModel | null) {
        this.workTaskEvaluationGroup = item;
        this.workTaskEvaluations = this.workTaskEvaluationGroup?.workTaskEvaluations ?? [];
    }

    showGroupDialogClick (item: WorkTaskEvaluationGroupModel) {
        const index = this.workTaskEvaluationGroups.indexOf(item);
        const previousWorkTaskEvaluationGroup = index + 1 < this.workTaskEvaluationGroups.length ? this.workTaskEvaluationGroups[index + 1] : null;
        this.evaluationDialog.open(item.id, this.partyId, cloneDeep(item), previousWorkTaskEvaluationGroup);
    }

}
